import * as chains from "../constants/chains";

const useExploreLink = () => {
  const convertExploreLink = (chainId, address) => {
    let blockExplorerUrl = "";
    for (const [key, value] of Object.entries(chains.chainConfigs)) {
      if (chainId == value.chainId) {
        blockExplorerUrl = value.blockExplorerUrls[0];
        break;
      }
    }

    return `${blockExplorerUrl}/address/${address}`;
  };

  return [convertExploreLink];
};

export default useExploreLink;
